module.exports = __webpack_public_path__ + "img/google_freq.207255dd.jpg";